import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { triggerInitiateRepaymentApiCallSuccess } from 'redux/actions';
import { TRIGGER_INITIATE_REPAYMENT_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';
import { nativeHandler } from 'utils';

function* triggerInitiateRepaymentApiCall(actions) {
	const { data, callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: API_CONSTANT.URL.INITIATE_REPAYMENT,
		data,
		method: 'POST',
		options: {
			dontRemoveLoader: true,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			// callback && callback(apiData)
			yield put(triggerInitiateRepaymentApiCallSuccess(apiData));
			localStorage.setItem('orderId', apiData?.orderId);
			nativeHandler.openDeepLinkWithCallback(apiData?.paymentURIDeeplink, () => {
				nativeHandler.removeLoader();
				callback(apiData?.orderId);
			});
		}
	} else {
		if (api.status === 500) {
			toast.error(api.data.message);
		}
		nativeHandler.removeLoader();
	}
}

export default function* triggerInitiateRepaymentApiCallSaga() {
	yield takeEvery(TRIGGER_INITIATE_REPAYMENT_API_CALL, triggerInitiateRepaymentApiCall);
}
